import React, { useState, useContext, useEffect } from "react";
import DataTableComponent from "react-data-table-component";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ViewListIcon from "@mui/icons-material/ViewModule";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import IconButton from "@mui/material/IconButton";
import { Chip } from "@material-ui/core";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/Admin/AuthService";
import ProductService from "../../../../services/Admin/ProductService";
import PgService from "../../../../services/Admin/PgService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

import common from "../../../../utill/Common";

const PgReportSection = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [isLoading, setIsLoading] = useState(false);

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10),
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [status, setStatus] = useState();
  const [gatewayName, setGatewayName] = useState(null);
  const [paymentMode, setPaymentMode] = useState(null);
  const [useCase, setUseCase] = useState();
  const [userId, setUserId] = useState();

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState();
  const [count, setCount] = useState();
  const [data, setData] = useState();

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedData, setSelectedData] = useState();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchText]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await PgService.report(
        token,
        fromDate,
        toDate,
        gatewayName,
        paymentMode,
        useCase,
        status,
        props.searchText,
        searchText,
        page,
        size,
        true,
      );

      const status1 = responseData.status;
      const message = responseData.message;

      if (status1 === "SUCCESS") {
        setData(responseData.data.result);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    setIsLoading(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "User ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.tbl_user.user_id}</span> <br />
          <small>{row.tbl_user.name}</small>
        </div>
      ),
    },
    {
      name: "Gateway Name",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.gateway_name}</span>
        </div>
      ),
    },
    {
      name: "Use Case",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.use_case}</span>
        </div>
      ),
    },
    {
      name: "Amount",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            ₹{row.amount}
          </span>
        </div>
      ),
    },
    {
      name: "Order ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.order_id}</span>
          <br />
          <small>{row.partner_order_id}</small>
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <h5>
                  <span class="badge badge-success">SUCCESS</span>
                </h5>
              );
            } else if (row.status === "FAILED") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            } else if (row.status === "PENDING") {
              return (
                <h5>
                  <span class="badge badge-warning">PENDING</span>
                </h5>
              );
            } else if (row.status === "REVERSAL") {
              return (
                <h5>
                  <span class="badge badge-danger">REVERSAL</span>
                </h5>
              );
            } else if (row.status === "REFUND") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            }
          })()}
        </div>
      ),
    },
    {
      name: "Date Time",
      cell: (row) => (
        <div>
          <span>{row.created_on}</span>
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            type="button"
            class="btn btn-dark btn-sm"
            onClick={() => {
              checkStatusHandler(row.order_id);
            }}
          >
            <i class="fas fa-sync"></i> Check Status
          </button>
        </div>

        // <div>
        //   <IconButton
        //     color="primary"
        //     id="basic-button"
        //     aria-controls={open ? "basic-menu" : undefined}
        //     aria-haspopup="true"
        //     aria-expanded={open ? "true" : undefined}
        //     onClick={(event) => {
        //       handleClick(event);
        //       setSelectedData(row);
        //     }}
        //   >
        //     <MenuOpenIcon />
        //   </IconButton>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={() => {
        //       setSelectedData(row);
        //       setOpenDialog(true);
        //     }}
        //   >
        //     <ViewListIcon />
        //   </IconButton>

        //   <Menu
        //     id="basic-menu"
        //     anchorEl={anchorEl}
        //     open={open}
        //     onClose={handleClose}
        //     MenuListProps={{
        //       "aria-labelledby": "basic-button",
        //     }}
        //   >
        //     <MenuItem
        //       onClick={() => {
        //         checkStatusHandler(selectedData.order_id);
        //       }}
        //     >
        //       Check Status
        //     </MenuItem>
        //   </Menu>
        // </div>
      ),
    },
  ];

  const checkStatusHandler = async (order_id) => {
    const access_token = AuthService.getAccessToken();

    const url =
      common.baseUrl +
      `admin/pg/check_status?order_id=${order_id}&access_token=${access_token}`;

    window.open(url, "_blank");

    // loadingCtx.startLoading();

    // try {
    //   const token = AuthService.getAccessToken();

    //   const responseData = await PgService.checkStatus(token, order_id);

    //   const status = responseData.status;
    //   const message = responseData.message;

    //   if (status == "SUCCESS") {
    //     const log = responseData.data ? responseData.data.log : null;

    //     Swal.fire({
    //       title: message,
    //       text: log ? JSON.stringify(log) : "null",
    //     });
    //   } else {
    //     Swal.fire("Opps!", message, "error");
    //   }
    // } catch (error) {
    //   const errMsg = HttpError.getError(error);
    //   Swal.fire("Opps!", errMsg, "error");
    // }

    // loadingCtx.stopLoading();
  };

  return (
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-header">
                <h3 class="card-title">PG Report</h3>
              </div>

              <div class="card-body">
                <div class="row mt-2">
                  <div class="col-md-12 mx-auto">
                    <form autoComplete="off">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="From Date"
                              onChange={(e) => {
                                setFromDate(e.target.value);
                              }}
                              defaultValue={fromDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="date"
                              class="form-control"
                              placeholder="To Date"
                              onChange={(e) => {
                                setToDate(e.target.value);
                              }}
                              defaultValue={toDate}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                            >
                              <option value="">Select Status</option>
                              <option value="SUCCESS">SUCCESS</option>
                              <option value="PENDING">PENDING</option>
                              <option value="REFUND">FAILED</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setGatewayName(e.target.value);
                              }}
                            >
                              <option value="">Select Gateway Name</option>
                              <option value="CASHFREE">CASHFREE</option>
                              <option value="EASEBUZZ">EASEBUZZ</option>
                              <option value="PAYU">PAYU</option>
                              <option value="RAZORPAY">RAZORPAY</option>
                              <option value="UPI GATEWAY">UPI GATEWAY</option>
                              <option value="ALL IN ONE UPI GATEWAY">
                                ALL IN ONE UPI GATEWAY
                              </option>
                              <option value="ONE GATEWAY">ONE GATEWAY</option>
                              <option value="AIRPAY">AIRPAY</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setPaymentMode(e.target.value);
                              }}
                            >
                              <option value="">Select Payment Mode</option>
                              <option value="UPI_INTENT">UPI_INTENT</option>
                              <option value="UPI_COLLECT">UPI_COLLECT</option>
                              <option value="UPI_QR">UPI_QR</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <select
                              className="form-control"
                              onChange={(e) => {
                                setUseCase(e.target.value);
                              }}
                            >
                              <option value="">Select Use Case</option>
                              <option value="UPI_TOPUP">UPI_TOPUP</option>
                              <option value="PG_TOPUP">PG_TOPUP</option>
                              <option value="PPI_TOPUP">PPI_TOPUP</option>
                              <option value="KYC_VERIFICATION_CHARGE">
                                KYC_VERIFICATION_CHARGE
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="User ID"
                              defaultValue={userId}
                              onChange={(e) => {
                                setUserId(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search Text"
                              onChange={(e) => {
                                setSearchText(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div class="col-sm-3" style={{ textAlign: "center" }}>
                          <div class="d-grid gap-2 d-md-flex">
                            <button
                              type="button"
                              class="btn btn-primary mr-4"
                              onClick={() => {
                                fetchData();
                              }}
                            >
                              <i class="fa fa-search"></i> Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <DataTableComponent
                  noHeader={true}
                  columns={columns}
                  data={data}
                  progressPending={isLoading}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={count}
                  paginationPerPage={size}
                  onChangePage={(page) => {
                    setPage(page);
                    fetchData();
                  }}
                  paginationRowsPerPageOptions={[
                    10, 20, 50, 100, 200, 500, 1000,
                  ]}
                  onChangeRowsPerPage={(size) => {
                    setSize(size);
                    fetchData();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PgReportSection;
